const gazableButtons = {
  squareButton: "gazable-square-button",
  squareButtonTwo: "gazable-square-button-two",
  squareButtonThree: "gazable-square-button-three",
};

export default gazableButtons;
